import React, { useState } from 'react';
import { TextInput } from '@manulife/mux';
import { InputLayout } from './InputLayout';
import { generateCustomStyles } from '../../../styles/input.styles';
import { validateEmail } from 'utils/commonLogics';

export const BasicInput = (props) => {
  const [emailError, setEmailError] = useState(null);
  const isError = emailError || props.error;

  const styles = {
    ...generateCustomStyles(isError, props.disabled),
    ...props.customStyles,
  };

  const validate = (e) => {
    if (props.type === 'email') {
      const isValidNum = validateEmail(e);
      setEmailError(isValidNum ? null : ' Invalid Email');
    }
  };

  return (
    <InputLayout
      {...props}
      error={isError}
      showErrorText={emailError || props.showErrorText}
    >
      <TextInput
        {...props}
        variant={TextInput.VARIANT.BASIC_LINE}
        placeholder={props.placeholder}
        value={props.value}
        onChange={(val) => props.onChange(val, props.name)}
        type={props.type}
        mask={props.mask}
        disabled={props.disabled}
        label={props.label || ''}
        customStyle={styles}
        onBlur={(val) => validate(val)}
      />
    </InputLayout>
  );
};
